<template>
  <svg viewBox="5 5 40 40">
    <g id="icons">
      <g id="TSBjAz.tif" class="st0">
        <image
          style="display: inline; overflow: visible"
          width="231"
          height="208"
          id="Layer_0_1_"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAADVCAYAAABpNH0XAAAACXBIWXMAAEnRAABJ0QEF/KuVAAAA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"
          transform="matrix(0.15 0 0 0.15 8.744 5.8048)"
        ></image>
      </g>
      <path
        d="M28.96,33.43c-0.02-0.16-0.58-3.99,0.98-5.95c1.14-1.44,3.27-4.12,3.27-7.5c0-3.04-3.19-7.62-8-7.62
		c-4.87,0-8.06,4.59-8.06,7.62c0,3.38,2.12,6.06,3.27,7.5c1.55,1.95,1.18,5.7,1.17,5.86l-1-0.1c0-0.03,0.34-3.51-0.96-5.14
		c-1.22-1.53-3.48-4.39-3.48-8.12c0-3.43,3.59-8.62,9-8.62c5.47,0,9.06,5.19,9.06,8.62c0,3.73-2.27,6.59-3.48,8.12
		c-1.07,1.35-0.92,4.19-0.77,5.18L28.96,33.43z"
      />
      <path
        d="M29.05,36.29h-7.5c-0.91,0-1.66-0.74-1.66-1.66s0.74-1.66,1.66-1.66h7.5c0.91,0,1.66,0.74,1.66,1.66
		S29.97,36.29,29.05,36.29z M21.55,33.98c-0.36,0-0.66,0.29-0.66,0.66s0.29,0.66,0.66,0.66h7.5c0.36,0,0.66-0.29,0.66-0.66
		s-0.29-0.66-0.66-0.66H21.55z"
      />
      <path
        d="M29.05,38.61h-7.5c-0.91,0-1.66-0.74-1.66-1.66s0.74-1.66,1.66-1.66h7.5c0.91,0,1.66,0.74,1.66,1.66
		S29.97,38.61,29.05,38.61z M21.55,36.29c-0.36,0-0.66,0.29-0.66,0.66s0.29,0.66,0.66,0.66h7.5c0.36,0,0.66-0.29,0.66-0.66
		s-0.29-0.66-0.66-0.66H21.55z"
      />
      <path
        d="M29.05,40.92h-7.5c-0.91,0-1.66-0.74-1.66-1.66s0.74-1.66,1.66-1.66h7.5c0.91,0,1.66,0.74,1.66,1.66
		S29.97,40.92,29.05,40.92z M21.55,38.61c-0.36,0-0.66,0.29-0.66,0.66s0.29,0.66,0.66,0.66h7.5c0.36,0,0.66-0.29,0.66-0.66
		s-0.29-0.66-0.66-0.66H21.55z"
      />
      <path
        d="M16.02,14.67c-0.1,0-0.2-0.03-0.28-0.09l-4.75-3.25c-0.23-0.16-0.29-0.47-0.13-0.69c0.16-0.23,0.47-0.29,0.69-0.13
		l4.75,3.25c0.23,0.16,0.29,0.47,0.13,0.69C16.34,14.59,16.18,14.67,16.02,14.67z"
      />
      <path
        d="M13.58,21.54H8.33c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h5.25c0.28,0,0.5,0.22,0.5,0.5S13.86,21.54,13.58,21.54z"
      />
      <path
        d="M11.27,31.73c-0.15,0-0.31-0.07-0.4-0.21c-0.16-0.22-0.11-0.54,0.11-0.7l4.81-3.5c0.22-0.16,0.54-0.11,0.7,0.11
		c0.16,0.22,0.11,0.54-0.11,0.7l-4.81,3.5C11.48,31.7,11.37,31.73,11.27,31.73z"
      />
      <path
        d="M34.4,14.67c-0.16,0-0.32-0.08-0.41-0.22c-0.16-0.23-0.1-0.54,0.13-0.69l4.75-3.25c0.23-0.16,0.54-0.1,0.7,0.13
		c0.16,0.23,0.1,0.54-0.13,0.69l-4.75,3.25C34.59,14.64,34.49,14.67,34.4,14.67z"
      />
      <path
        d="M42.08,21.54h-5.25c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h5.25c0.28,0,0.5,0.22,0.5,0.5S42.36,21.54,42.08,21.54z"
      />
      <path
        d="M39.15,31.73c-0.1,0-0.21-0.03-0.29-0.1l-4.81-3.5c-0.22-0.16-0.27-0.48-0.11-0.7c0.16-0.22,0.48-0.27,0.7-0.11l4.81,3.5
		c0.22,0.16,0.27,0.47,0.11,0.7C39.45,31.66,39.3,31.73,39.15,31.73z"
      />
    </g>
    <g id="kader" class="st0">
      <g class="st1">
        <g>
          <g>
            <path
              class="st2"
              d="M46.38,0.98c1.47,0,2.66,1.19,2.66,2.66v42.72c0,1.47-1.19,2.66-2.66,2.66H3.66C2.19,49.03,1,47.84,1,46.37
					V3.64c0-1.47,1.19-2.66,2.66-2.66H46.38 M46.38-0.02H3.66C1.64-0.02,0,1.62,0,3.64v42.72c0,2.02,1.64,3.66,3.66,3.66h42.72
					c2.02,0,3.66-1.64,3.66-3.66V3.64C50.05,1.62,48.41-0.02,46.38-0.02L46.38-0.02z"
            />
          </g>
        </g>
        <rect x="5.48" y="5.46" class="st3" width="39.08" height="39.08" />
      </g>
      <g class="st1">
        <g>
          <path
            class="st2"
            d="M46.38,0.98c1.47,0,2.66,1.19,2.66,2.66v42.72c0,1.47-1.19,2.66-2.66,2.66H3.66C2.19,49.03,1,47.84,1,46.37
				V3.64c0-1.47,1.19-2.66,2.66-2.66H46.38 M46.38-0.02H3.66C1.64-0.02,0,1.62,0,3.64v42.72c0,2.02,1.64,3.66,3.66,3.66h42.72
				c2.02,0,3.66-1.64,3.66-3.66V3.64C50.05,1.62,48.41-0.02,46.38-0.02L46.38-0.02z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconLamp extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  display: none;
}

.st1 {
  display: inline;
}

.st2 {
  fill: #0a0a0a;
}

.st3 {
  fill: none;
  stroke: #00aae1;
  stroke-miterlimit: 10;
}
</style>
